"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/* eslint-disable */
var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FollowArtistButton_artist",
  "selections": [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "internalID",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }, {
    "alias": "is_followed",
    "args": null,
    "kind": "ScalarField",
    "name": "isFollowed",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "concreteType": "ArtistCounts",
    "kind": "LinkedField",
    "name": "counts",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "follows",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "Artist"
};
node.hash = '37ce17e390ffcba91d38b16acc1b87d5';
var _default = node;
exports.default = _default;
//# sourceMappingURL=FollowArtistButton_artist.graphql.js.map